var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.591,
    height: 10.36,
    viewBox: "0 0 15.591 10.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(-0.9 -5.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37954",
    "data-name": "Path 37954",
    d: "M1.5,10.58S4.116,6,8.7,6s7.2,4.58,7.2,4.58-2.616,4.58-7.2,4.58S1.5,10.58,1.5,10.58Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6D93BD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37955",
    "data-name": "Path 37955",
    d: "M16.326,14.913A1.413,1.413,0,1,1,14.913,13.5,1.413,1.413,0,0,1,16.326,14.913Z",
    transform: "translate(-6.218 -4.435)",
    fill: "none",
    stroke: "#6D93BD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b57e4a68788abec710a75bba7b316979.svg";
export { ForwardRef as ReactComponent };